const langText = {
  en: {
    noActivityAlert: 'No Activity Alert',
    noStartAlert: 'No Start Alert',
    noActivityDesc: 'There has been no activity on this T-Code for <b>%s</b> days',
    otherTcodeDesc: 'Other T-code for this patient:',
    carePlanHeader:
      'We are going to be <b>checking-in with you</b> during the time between appointments. On a regular schedule, your cell phone or tablet will alert you that we are checking in, and we will ask you to complete a simple <b>Reply Form</b>. This ongoing process of getting information from you about your health is called a <b>"Journey"</b>. It is how we stay aware of your conditions as time passes from your last office visit to your next appointment. Each condition has its own Journey, its own special questions. These are the Journeys you are on:',
    carePlanFooter:
      'It is very important for you to complete and send in the Reply Form each time we check-in with you. The information you supply helps us keep track of your health, and it may provide an early indication if there is anything that needs attention. We are using mobile devices because they provide an easy, convenient and proven way to keep you as healthy as possible. Your part in this is necessary, help us make this work for you.',
    carePlanFor: 'CARE PLAN FOR',
    date: 'DATE',
    yourRole: 'Your Role',
    journey: 'Journey',
    tcode: 'T-Code',
  },
  es: {
    noActivityAlert: 'Alerta de no actividad',
    noStartAlert: 'No hay alerta de inicio',
    noActivityDesc: 'No ha habido actividad en este Código-T durante %s días',
    otherTcodeDesc: 'Otro Código-T para esta paciente:',
    carePlanHeader:
      'Vamos a estar <b>en contacto con usted</b> durante el tiempo que transcurre entre sus citas. En un horario regular, su celular o su tableta lo alertaran de que lo estamos contactando, y le pediremos que complete un simple <b>Formulario de Respuesta</b>. Este proceso continuo de obtener información por parte de usted acerca de su salud se llama <b>"Trayecto."</b> Así es como estamos al pendiente de sus padecimientos a medida que pasa el tiempo entre su última visita y su próxima cita. Cada padecimiento tiene su propio Trayecto, sus propias preguntas especiales. Estos son los Trayectos que le corresponden:',
    carePlanFooter:
      'Es muy importante que complete y envíe el Formulario de Respuesta cada vez que nos pongamos en contacto con usted. La información que usted proporciona nos ayuda a llevar un registro de su salud, y podrá darnos una señal temprana si es que existe algo que requiere de atención. Estamos usando aparatos móviles por que estos proveen una forma fácil, conveniente y comprobada de mantenerlo tan saludable como sea posible. Su participación es necesaria, ayúdenos a que esto funcione para usted.',
    carePlanFor: 'PLAN DE CUIDADO PARA',
    date: 'FECHA',
    yourRole: 'Su Rol',
    journey: 'Trayecto',
    tcode: 'Código-T',
  },
};

export const i18nText = (text, lang = 'en', replacement = []) => {
  let newText = langText[lang][text];

  if (replacement.length > 0) {
    newText = replacement.reduce((acc, item) => {
      return acc.replace('%s', item);
    }, newText);
  }

  return newText;
};
